import HeaderPlayButton from './HeaderPlayButton';
import PlayerStateProxy from 'components/Player/PlayerState/PlayerStateProxy';

export default PlayerStateProxy(HeaderPlayButton);
